import {applyMiddleware, createStore} from 'redux';
import logger from 'redux-logger';
import reducer from "./reducers/rootReducer";
import JSZip from 'jszip';

export const initState = {
    creds: {
        firstname: '',
        lastname: '',
        phone: '',
        email: ''
    },
    files: new JSZip(),
    orders: [
        // {
        //     name: '',
        //     files: {size: 0, count: 0, zip: blob},
        //     details: {
        //         subcat1: 'bla bla $1',
        //         subcat2: 'bar $1 bar $2'
        //     },
        //     deadline: '',
        // }
    ],
    comment: ''
};

export default process.env.NODE_ENV === 'development' ?
    createStore(reducer, initState, applyMiddleware(logger)) :
    createStore(reducer, initState);




// WEBPACK FOOTER //
// ./src/app/store.js